/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import PreferencesSettings from '../PreferencesSettings';
import SelectComponent from '../../common/AutoSuggestSelect/Select';
import '../preference.scss';
import './suppressfields.scss';
import { OPTIONS } from '../../../../constants/index';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { Loader } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import ToastMessage from '../../common/ToastMessage';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../../errorhandling/HttpErrorCodes';
import AutoSuggestionSelectComponent from '../../common/auto-suggestion-select/Select';
import { setAppConfig } from '../../../../redux/app/appSlice';
import GenericButton from '../../../../Components/GenericButton/GenericButton';

import { CreateAdminConfig } from '../../../utils/common';
import Checkbox from '../../common/Checkbox';
import { maskedOther, maskedSSN } from 'src/common/masking';
import MasterPermissions from '../../../api/MasterPermissions';

export default function SuppressFields(props) {
  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { appConfigs } = useSelector((state) => state.app) || {};
  const [updatedAppConfigs, setupdatedAppConfigs] = useState(appConfigs);

  const [suppressSettings, setSuppressSettings] = useState(
    Suppress_Setting?.SSN
      ? { label: Suppress_Setting.SSN, value: Suppress_Setting.SSN }
      : false,
  );
  const [suppressSettingsSSNCheck, setSuppressSettingsSSNCheck] = useState(
    Suppress_Setting?.SSN ? true : false,
  );

  const [suppressSettingsMemberID, setSuppressSettingsMemberID] = useState(
    Suppress_Setting?.memberId
      ? { label: Suppress_Setting.memberId, value: Suppress_Setting?.memberId }
      : false,
  );
  const [suppressSettingsMemberIDCheck, setSuppressSettingsMemberIDCheck] =
    useState(Suppress_Setting?.memberId ? true : false);

  const [suppressSettingsAltID1, setSuppressSettingsAltID1] = useState(
    Suppress_Setting?.altId1
      ? { label: Suppress_Setting.altId1, value: Suppress_Setting?.altId1 }
      : false,
  );
  const [suppressSettingsAltID1Check, setSuppressSettingsAltID1Check] =
    useState(Suppress_Setting?.altId1 ? true : false);

  const [suppressSettingsAltID2, setSuppressSettingsAltID2] = useState(
    Suppress_Setting?.altId2
      ? { label: Suppress_Setting.altId2, value: Suppress_Setting?.altId2 }
      : false,
  );
  const [suppressSettingsAltID2Check, setSuppressSettingsAltID2Check] =
    useState(Suppress_Setting?.altId2 ? true : false);

  const [ssn, setSsn] = useState();
  const [memberId, setMemberId] = useState();
  const [altId1, setAltId1] = useState();
  const [altId2, setAltId2] = useState();

  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const initialSetup = {
      SSN: Suppress_Setting?.SSN ? Suppress_Setting?.SSN : false,
      memberId: Suppress_Setting?.memberId ? Suppress_Setting.memberId : false,
      altId1: Suppress_Setting?.altId1 ? Suppress_Setting.altId1 : false,
      altId2: Suppress_Setting?.altId2 ? Suppress_Setting.altId2 : false,
    };

    setupdatedAppConfigs((current) => {
      //👇️ using spread syntax (...)

      return {
        ...current,
        Suppress_Setting: {
          ...current.Suppress_Setting,

          //👇️ override value for nested country property
          ...initialSetup,
        },
      };
    });
  }, []);

  useEffect(() => {
    setSsn(
      maskedSSN(
        suppressSettings?.value ? suppressSettings?.value : false,
        '837480818',
      ),
    );
    setMemberId(
      maskedOther(
        suppressSettingsMemberID?.value
          ? suppressSettingsMemberID?.value
          : false,
        '123456789098765',
      ),
    );
    setAltId1(
      maskedOther(
        suppressSettingsAltID1?.value ? suppressSettingsAltID1?.value : false,
        '123456789098765',
      ),
    );
    setAltId2(
      maskedOther(
        suppressSettingsAltID2?.value ? suppressSettingsAltID2?.value : false,
        '123456789098765',
      ),
    );
  }, [
    suppressSettings,
    suppressSettingsMemberID,
    suppressSettingsAltID1,
    suppressSettingsAltID2,
  ]);

  const onChangeHandler = (selectedValue, field) => {
    const updatedValues = {};
    if (field === 'SSN') {
      updatedValues.SSN = selectedValue?.value || false;
      setSuppressSettings(selectedValue);
    } else if (field === 'memberId') {
      updatedValues.memberId = selectedValue?.value || false;
      setSuppressSettingsMemberID(selectedValue);
    } else if (field === 'altId1') {
      updatedValues.altId1 = selectedValue?.value || false;
      setSuppressSettingsAltID1(selectedValue);
    } else if (field === 'altId2') {
      updatedValues.altId2 = selectedValue?.value || false;
      setSuppressSettingsAltID2(selectedValue);
    }
    setupdatedAppConfigs((current) => {
      //👇️ using spread syntax (...)

      return {
        ...current,
        Suppress_Setting: {
          ...current.Suppress_Setting,

          //👇️ override value for nested country property
          ...updatedValues,
        },
      };
    });
  };

  const updateTimeAndDate = async () => {
    const saveJson = CreateAdminConfig(updatedAppConfigs);
    console.log('updatedAppConfigs', updatedAppConfigs);
    return await axiosInstance.put(
      APIEndpoints.putUpdateConfiguration(),
      JSON.stringify(saveJson),
    );
  };
  const handleSubmit = async () => {
    try {
      const response = await updateTimeAndDate();
      if (HttpSuccessCodes.HTTP_SUCCESS_CODE_200 === response.status) {
        dispatch(setAppConfig(updatedAppConfigs));
      }
      toast.success(
        <ToastMessage type="success" subTitle={'Updated SSN successfully'} />,
      );
    } catch (error) {
      console.log(error);
      if (error.toString().includes('409')) {
        toast.warning(
          <ToastMessage
            type="warning"
            subTitle={'No changes were made! Select another SSN and try again.'}
          />,
        );
      } else {
        toast.error(
          <ToastMessage type="error" subTitle={'SSN updation failed'} />,
        );
      }
    }
  };

  return (
    <div>
      <Container className="mtop30 activationCode suppress-preference">
        <h2>Suppress Fields</h2>
        <Form>
          <Row>
            <Col md={8} lg={8} sm={8}>
              <p className="maintain_suppressfield mb-4">
                For security reasons, configure to display only last &lt;n&gt;
                digits.{' '}
              </p>

              <Form.Group controlId="formBasicSSN" className="mb-4">
                <div className="">
                  <Checkbox
                    inline
                    key="suppress-settings-ssn-Key"
                    label="Suppress SSN"
                    className="d-none"
                    value={suppressSettings}
                    id="suppress-settings-ssn"
                    name="suppress-settings-ssn"
                    onChange={(e) => {
                      setSuppressSettingsSSNCheck(!suppressSettingsSSNCheck);
                      if (!e.target.checked) {
                        onChangeHandler(false, 'SSN');
                      } else {
                        onChangeHandler(
                          Suppress_Setting?.SSN
                            ? {
                                label: Suppress_Setting.SSN,
                                value: Suppress_Setting.SSN,
                              }
                            : { label: 3, value: 3 },
                          'SSN',
                        );
                      }
                    }}
                    checked={suppressSettingsSSNCheck}
                    disabled={
                      !MasterPermissions.CheckPermission(
                        'Edit System Preference',
                      )
                    }
                    isDisabled={
                      !MasterPermissions.CheckPermission(
                        'Edit System Preference',
                      )
                    }
                  />
                </div>
                <Form.Label className="mt-3 text-format">SSN</Form.Label>
                <Row>
                  <Col md={6}>
                    <AutoSuggestionSelectComponent
                      options={OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="best-match-filter height-32"
                      value={suppressSettings}
                      onChange={(e) => onChangeHandler(e, 'SSN')}
                      isSearchable={false}
                      isDisabled={
                        !suppressSettingsSSNCheck ||
                        !MasterPermissions.CheckPermission(
                          'Edit System Preference',
                        )
                      }
                    />
                  </Col>
                </Row>
                {suppressSettings && suppressSettings?.value !== 'hide' && (
                  <span className="example-text1 d-inline-block pt-4">
                    Example: {ssn}
                  </span>
                )}
              </Form.Group>

              {/*<Form.Group controlId="formBasicMemberID" className="mb-4">
                <Form.Label className="text-format">
                  Member ID
                </Form.Label>
                <Row>
                  <Col>
                    {/*<Form.Control as="select">
                      <option>4</option>
                      <option>3</option>
                      <option>2</option>
                    </Form.Control> */}
              {/*<SelectComponent
                      options={OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="best-match-filter height-32"
                      value={OPTIONS[ 3 ]}
                      isSearchable={false}
                    />
                  </Col>
                </Row>
                <span className="example-text1 pt-4">
          Example: XXXXXXX2022
                </span>
              </Form.Group> */}

              {/*<Form.Group controlId="formBasiAlteranate" className="mb-4">
                <Form.Label className="text-format">
                  Alternate ID 1
                </Form.Label>
                <Row>
                  <Col> */}
              {/*<Form.Control as="select">
                      <option>4</option>
                      <option>3</option>
                      <option>2</option>
                    </Form.Control> */}
              {/*<SelectComponent
                      options={OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="best-match-filter height-32"
                      value={OPTIONS[ 3 ]}
                      isSearchable={false}
                    />
                  </Col>
                </Row>
                <span className="example-text1 pt-4">
          Example: XXXXXXX2022
                </span>
              </Form.Group> */}

              {/*<Form.Group controlId="formBasicAlt2" className="mb-4">
                <Form.Label className="text-format">
                  Alternate ID 2
                </Form.Label>
                <Row>
                  <Col> */}
              {/*<Form.Control as="select">
                      <option>4</option>
                      <option>3</option>
                      <option>2</option>
                    </Form.Control> */}
              {/*<SelectComponent
                      options={OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="best-match-filter height-32"
                      value={OPTIONS[ 2 ]}
                      isSearchable={false}
                    />
                  </Col>
                </Row>
                <span className="example-text1 pt-4">
          Example: XXXXXXX2022
                </span>
              </Form.Group> */}
            </Col>
          </Row>
          {/*Once QA team confirm uncomment this
          <div className="saperator" />
          <Row className="mt-4">
            <Col md={8} lg={8} sm={8}>
              <Form.Group controlId="formBasicMemberID" className="mb-4">
                <div className=''>
                    <Checkbox
                      inline
                      key="suppress-settings-memberID-Key"
                      label="Suppress Certificate Number"
                      className="d-none"
                      value={suppressSettingsMemberID}
                      id="suppress-settings-memberID"
                      name="suppress-settings-memberID"
                      onChange={( e ) => {
                        setSuppressSettingsMemberIDCheck(!suppressSettingsMemberIDCheck);
                        if(!e.target.checked) {
                          onChangeHandler(false, "memberId");
                        } else {
                          onChangeHandler(Suppress_Setting?.memberId ? {label: Suppress_Setting.memberId, value: Suppress_Setting.memberId} : {label: 3, value: 3}, "memberId")
                        }
                      }}
                      checked={suppressSettingsMemberIDCheck}
                    />
                  </div>
                <Form.Label className="mt-3 text-format">
                  Certificate Number
                </Form.Label>
                <Row>
                  <Col>
                    <AutoSuggestionSelectComponent
                      options={OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="best-match-filter height-32"
                      value={suppressSettingsMemberID}
                      onChange={(e) => onChangeHandler(e, "memberId")}
                      isSearchable={false}
                      isDisabled={!suppressSettingsMemberIDCheck}
                    />
                  </Col>
                </Row>
                {(suppressSettingsMemberID && suppressSettingsMemberID?.value !== 'hide') && <span className="example-text1 d-inline-block pt-4">
                  Example: {memberId}
                </span>}
              </Form.Group>
            </Col>
          </Row>
          <div className="saperator" />
          <Row className="mt-4">
            <Col md={8} lg={8} sm={8}>
              <Form.Group controlId="formBasicAltId1" className="mb-4">
                <div className=''>
                    <Checkbox
                      inline
                      key="suppress-settings-altId1-Key"
                      label="Suppress Alternate ID 1"
                      className="d-none"
                      value={suppressSettingsAltID1}
                      id="suppress-settings-altId1"
                      name="suppress-settings-altId1"
                      onChange={( e ) => {
                        setSuppressSettingsAltID1Check(!suppressSettingsAltID1Check);
                        if(!e.target.checked) {
                          onChangeHandler(false, "altId1");
                        } else {
                          onChangeHandler(Suppress_Setting?.altId1 ? {label: Suppress_Setting.altId1, value: Suppress_Setting.altId1} : {label: 3, value: 3}, "altId1")
                        }
                      }}
                      checked={suppressSettingsAltID1Check}
                    />
                  </div>
                <Form.Label className="mt-3 text-format">
                  Alternate ID 1
                </Form.Label>
                <Row>
                  <Col>
                    <AutoSuggestionSelectComponent
                      options={OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="best-match-filter height-32"
                      value={suppressSettingsAltID1}
                      onChange={(e) => onChangeHandler(e, "altId1")}
                      isSearchable={false}
                      isDisabled={!suppressSettingsAltID1Check}
                    />
                  </Col>
                </Row>
                {(suppressSettingsAltID1 && suppressSettingsAltID1?.value !== 'hide') &&<span className="example-text1 d-inline-block pt-4">
                  Example: {altId1}
                </span>}
              </Form.Group>
            </Col>
          </Row>
          <div className="saperator" />
          <Row className="mt-4">
            <Col md={8} lg={8} sm={8}>
              <Form.Group controlId="formBasicAltId2" className="mb-4">
                <div className=''>
                    <Checkbox
                      inline
                      key="suppress-settings-altId1-Key"
                      label="Suppress Alternate ID 2"
                      className="d-none"
                      value={suppressSettingsAltID2}
                      id="suppress-settings-altId2"
                      name="suppress-settings-altId2"
                      onChange={( e ) => {
                        setSuppressSettingsAltID2Check(!suppressSettingsAltID2Check);
                        if(!e.target.checked) {
                          onChangeHandler(false, "altId2");
                        } else {
                          onChangeHandler(Suppress_Setting?.altId2 ? {label: Suppress_Setting.altId2, value: Suppress_Setting.altId2} : {label: 3, value: 3}, "altId2")
                        }
                      }}
                      checked={suppressSettingsAltID2Check}
                    />
                  </div>
                <Form.Label className="mt-3 text-format">
                  Alternate ID 2
                </Form.Label>
                <Row>
                  <Col>
                    <AutoSuggestionSelectComponent
                      options={OPTIONS}
                      components={{ IndicatorSeparator: () => null }}
                      inputClassName="best-match-filter height-32"
                      value={suppressSettingsAltID2}
                      onChange={(e) => onChangeHandler(e, "altId2")}
                      isSearchable={false}
                      isDisabled={!suppressSettingsAltID2Check}
                    />
                  </Col>
                </Row>
                {(suppressSettingsAltID2 && suppressSettingsAltID2?.value !== 'hide') && <span className="example-text1 d-inline-block pt-4">
                  Example: {altId2}
                </span>}
              </Form.Group>
            </Col>
          </Row>
                    */}
        </Form>
        <Row>
          <Col>
            <GenericButton
              onClick={handleSubmit}
              className="ml-1"
              disable={
                !MasterPermissions.CheckPermission('Edit System Preference')
              }
              buttonDisabled={
                !MasterPermissions.CheckPermission('Edit System Preference')
              }
            >
              SAVE
            </GenericButton>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
